import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as EditorActions from '../../../actions/editor';
import Renderer from './renderer';
import { setHighlight } from '../../../features/dataflow/highlightSlice';
import { setHover } from '../../../features/dataflow/hoverSlice';
export function mapStateToProps(state) {
    return {
        compiledEditorRef: state.compiledEditorRef,
        compiledVegaPaneSize: state.compiledVegaPaneSize,
        compiledVegaSpec: state.compiledVegaSpec,
        configEditorString: state.configEditorString,
        decorations: state.decorations,
        editorFocus: state.editorFocus,
        editorRef: state.editorRef,
        editorString: state.editorString,
        gist: state.gist,
        manualParse: state.manualParse,
        mode: state.mode,
        parse: state.parse,
        selectedExample: state.selectedExample,
        sidePaneItem: state.sidePaneItem,
        themeName: state.themeName,
        value: state.editorString,
        view: state.view,
        ranges: state.ranges,
        hover: state.hover,
        highlight: state.highlight,
    };
}
export function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        clearConfig: EditorActions.clearConfig,
        extractConfigSpec: EditorActions.extractConfigSpec,
        logError: EditorActions.logError,
        mergeConfigSpec: EditorActions.mergeConfigSpec,
        parseSpec: EditorActions.parseSpec,
        setConfig: EditorActions.setConfig,
        setDecorations: EditorActions.setDecorations,
        setEditorFocus: EditorActions.setEditorFocus,
        setEditorReference: EditorActions.setEditorReference,
        updateEditorString: EditorActions.updateEditorString,
        updateVegaLiteSpec: EditorActions.updateVegaLiteSpec,
        updateVegaSpec: EditorActions.updateVegaSpec,
        setHighlight: setHighlight,
        setRanges: EditorActions.setRanges,
        setHover: setHover,
    }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(Renderer);
